import { fetchJson } from "Main/fetch-helper";
import { format } from "date-fns";

interface TSchedulable {
  schedule?: unknown;
}

/**
 * The counselor grid's own request, answered with schedules alone.
 *
 * Same parameters the grid sends (see prepareCounselorLoadParams), so the
 * footer promises a time from the very set of advisors the listing it links
 * to will show — the page it sits on never has that grid.
 */
export async function fetchAdvisorSchedules(
  role: string,
  city: string
): Promise<TSchedulable[]> {
  const themeVars = window.theme_vars;
  const params = new URLSearchParams({
    adminMarket: themeVars?.currentAdminMarket || "",
    competence: "",
    competenceSlug: "",
    limit: "0",
    location: city,
    role,
    siteId: String(themeVars?.currentSiteId || ""),
    skip_location_filtering: "true",
    start_date: format(new Date(), "yyyy-MM-dd"),
    timezone: "",
  });

  const { data } = await fetchJson<{ data: TSchedulable[] }>(
    `/wp-json/lavendla/v1/advisor-schedules?${params}`
  );

  return data || [];
}
